import type { PromptTabs } from "@1js/pl-card-components";
import { useNavigate } from "react-router-dom";
import { readFromMetaTags } from "../utils/Telemetry/config";
import { resetTelemetryLoggerSinks } from "../utils/Telemetry/getTelemetryLogger";

/**
 * Hook to get the current logged in user
 * @returns current logged in user or undefined if not logged in
 */
export const useRouterNavigate = () => {
  const navigate = useNavigate();
  // const [selectedNavItem, setSelectedNavItem] = React.useState<PromptTabs>(
  //   PromptTabs.Home
  // );
  //const context = React.useContext(MetaOSAppContext);
  const routerNavigate = (
    path: string,
    navItem?: PromptTabs,
    deepLinkPromptId?: string
  ) => {
    resetTelemetryLoggerSinks();
    // console.log(selectedNavItem);

    let routePath = `${path}?hostName=${readFromMetaTags("awa-hostName")}&hostClientType=${readFromMetaTags("awa-hostClientType")}`;

    if (deepLinkPromptId) {
      routePath += `&deepLinkPromptId=${deepLinkPromptId}`;
    }

    if (navItem) {
      // setSelectedNavItem(navItem);
      //context.updateContext({ ...context, selectedNavItem: navItem });
      routePath += `&type=${navItem}`;
    }

    navigate(routePath);
  };

  return routerNavigate;
};
